class ProductGallerySlider extends InitSwiper {
  constructor() {
    super();
    //implementation
    this.swiperEl = this.getElementById("product-gallery-slider");

    console.log("this.swiperEl", this.swiperEl);
  }

  connectedCallback() {
    //implementation
  }

  disconnectedCallback() {
    //implementation
  }

  attributeChangedCallback(name, oldVal, newVal) {
    //implementation
  }

  adoptedCallback() {
    //implementation
  }

}

window.customElements.define('product-gallery-slider', ProductGallerySlider);